import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import { ScrollToTop } from './components/ScrollToTop';
import { Layout } from './components/Layout/Layout';
import Home from './pages/Home';
import Login from './pages/Login';
import Signup from './pages/Signup';
import WordMasterPage from './pages/WordMasterPage';
import CrosswordPage from './pages/CrosswordPage';
import LeaderboardPage from './pages/LeaderboardPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsOfUsePage from './pages/TermsOfUsePage';
import FullCrosswordPage from './pages/FullCrosswordPage';
import LetterHivePage from './pages/LetterHivePage';
import WordRungsPage from './pages/WordRungsPage';
import DownloadAppPage from './pages/DownloadAppPage';
import AboutPage from './pages/AboutPage';
import FaqPage from './pages/FaqPage';
import HowToPlayPage from './pages/HowToPlayPage';
import FeedbackPage from './pages/FeedbackPage';
import AccountDeletionPage from './pages/AccountDeletionPage';
import AccountPage from './pages/AccountPage';

function VercelAnalytics() {
  if (process.env.NODE_ENV !== 'production') return null;
  try {
    // eslint-disable-next-line global-require
    const { Analytics } = require('@vercel/analytics/react');
    return <Analytics />;
  } catch (_) {
    return null;
  }
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="word-master" element={<WordMasterPage />} />
        <Route path="crossword" element={<CrosswordPage />} />
        <Route path="crossword-full" element={<FullCrosswordPage />} />
        <Route path="letter-hive" element={<LetterHivePage />} />
        <Route path="word-rungs" element={<WordRungsPage />} />
        <Route path="leaderboard" element={<LeaderboardPage />} />
        <Route path="privacy" element={<PrivacyPolicyPage />} />
        <Route path="terms" element={<TermsOfUsePage />} />
        <Route path="apps" element={<DownloadAppPage />} />
        <Route path="about" element={<AboutPage />} />
        <Route path="faq" element={<FaqPage />} />
        <Route path="how-to-play" element={<HowToPlayPage />} />
        <Route path="feedback" element={<FeedbackPage />} />
        <Route path="account-deletion" element={<AccountDeletionPage />} />
        <Route path="account" element={<AccountPage />} />
        <Route path="login" element={<Login />} />
        <Route path="signup" element={<Signup />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <HelmetProvider>
      <ThemeProvider>
        <AuthProvider>
          <BrowserRouter>
            <ScrollToTop />
            <AppRoutes />
          </BrowserRouter>
        </AuthProvider>
      </ThemeProvider>
      <VercelAnalytics />
    </HelmetProvider>
  );
}

export default App;
